import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import { DefaultLayoutComponent } from "./containers";
import { LoginComponent } from "./views/login/login.component";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app.routing";
import { ForgotPasswordComponent } from "./views/forgot-password/forgot-password.component";
import { MessageModule } from "./components/message/message.module";
import { HttpModule } from '@angular/http';
import { PushNotificationService } from "./shared/services/push-notification.service";
import { MessagingService } from "./shared/services/messaging-service";
import { DeletedUsersComponent } from './components/deleted-users/deleted-users.component';
import { SsoLoginComponent } from "./views/sso-login/sso-login.component";


@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    BrowserAnimationsModule,
    PerfectScrollbarModule,
    MessageModule,
    HttpModule,
 
  ],
  declarations: [
    AppComponent,
    SsoLoginComponent,
    // ...APP_CONTAINERS,
    LoginComponent,
    DefaultLayoutComponent,
    ForgotPasswordComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    MessagingService,
    PushNotificationService
  ],
  exports: [BrowserAnimationsModule, MessageModule],

  bootstrap: [AppComponent],
})
export class AppModule {}

// export function HttpLoaderFactory(handler: HttpBackend) {
//   let http=new HttpClient(handler);
//   return new TranslateHttpLoader(http);
// }
